// extracted by mini-css-extract-plugin
export default {"addTodoForm":"AddTodo_addTodoForm__Hy41j","btn":"AddTodo_btn__HPsyN","inputTask":"AddTodo_inputTask__y5s9z","buttonTask":"AddTodo_buttonTask__Avm7X"};